import { GridFilterModel, GridSortModel } from '@mui/x-data-grid';
import { RouteCardsQueryParams, RouteCardsSortBy } from '../interfaces';

// Unlike onboard-devices, the route-cards backend only supports plain
// equality filters on these two fields (?deviceId=&status=), not a
// JSON-encoded filters array with operators - keep the grid's filterable
// surface matching that exactly so it never looks like it filters but
// silently does nothing.
export const ROUTE_CARD_SERVER_SORT_FIELDS = new Set<string>([
    'deviceId',
    'status',
    'createdAt',
    'updatedAt',
]);
export const ROUTE_CARD_SERVER_FILTER_FIELDS = new Set<string>(['deviceId', 'status']);

export const isRouteCardServerSortable = (field: string): boolean => {
    return ROUTE_CARD_SERVER_SORT_FIELDS.has(field);
};

export const isRouteCardServerFilterable = (field: string): boolean => {
    return ROUTE_CARD_SERVER_FILTER_FIELDS.has(field);
};

export const getRouteCardsSortQueryPatch = (
    model: GridSortModel,
): Pick<RouteCardsQueryParams, 'sortBy' | 'sortOrder'> => {
    const sortItem = model.find((item) => isRouteCardServerSortable(item.field) && item.sort);

    if (!sortItem) {
        return { sortBy: undefined, sortOrder: undefined };
    }

    return {
        sortBy: sortItem.field as RouteCardsSortBy,
        sortOrder: sortItem.sort === 'asc' ? 'asc' : 'desc',
    };
};

export const getRouteCardsFilterQueryPatch = (
    model?: GridFilterModel,
): Pick<RouteCardsQueryParams, 'deviceId' | 'status'> => {
    const patch: Pick<RouteCardsQueryParams, 'deviceId' | 'status'> = {
        deviceId: undefined,
        status: undefined,
    };

    model?.items?.forEach((item) => {
        if (!isRouteCardServerFilterable(item.field)) {
            return;
        }

        if (item.value === undefined || item.value === null || item.value === '') {
            return;
        }

        if (item.field === 'deviceId') {
            patch.deviceId = String(item.value);
        } else if (item.field === 'status') {
            patch.status = item.value;
        }
    });

    return patch;
};
